require('./lbDialog.scss');

const $inject = [];
const lbDialog = function () {
  return {
    controller: 'lbDialogCont',
    controllerAs: 'vm',
    bindToController: true,
    template: require('./lbDialog.html'),
    scope: {},
  };
};

lbDialog.$inject = $inject;

export default lbDialog;



// WEBPACK FOOTER //
// ./src/components/lbDialog/lbDialogDir.js